import { render, staticRenderFns } from "./PasswordChange.vue?vue&type=template&id=2661dd65&"
import script from "./PasswordChange.vue?vue&type=script&lang=js&"
export * from "./PasswordChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2661dd65')) {
      api.createRecord('2661dd65', component.options)
    } else {
      api.reload('2661dd65', component.options)
    }
    module.hot.accept("./PasswordChange.vue?vue&type=template&id=2661dd65&", function () {
      api.rerender('2661dd65', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PasswordChange.vue"
export default component.exports